angular.module('routes.users.UsersController', [
  'stack'
])

/**
 * The UsersController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class UsersController
 * @constructor
 * @module routes.users.UsersController
 */
.controller('UsersController', [
  '$scope',
  '$state',
  'ModelsService',
  'UsersService',
  function ($scope, $state, ModelsService, UsersService) {
    'use strict';

    $scope.constants = null;

    $scope.state = $state;

    $scope.users = {
      list: [],
      current: null
    };

    $scope.create = UsersService.getNew();

    $scope.roles = ['admin', 'author', 'qa'];

    // what value to sort on
    $scope.sortType = 'name';
    // default sort order ascending
    $scope.sortReverse = false;
    // start with no search
    $scope.searchLabel = '';

    $scope.deleteConfirm = null;

    /**
     * Update the groups of the povided user
     *
     * @param {Object} user - User model
     */
    $scope.updateGroups = function updateGroups(user) {
      saveEditUser(user);
    };

    /**
     * Create a new user based on the create model
     */
    $scope.saveCreateUser = function saveCreateUser() {
      UsersService
        .create($scope.create)
        .then(function () {
          $state.reload();
          return;
        })
        .catch(function (response) {
          console.log(response);
        });
    };

    /**
     * Toggle the role of the provided user
     *
     * @param {Object} user - User model
     * @param {string} role - Role in which to toggle
     * @param {boolean} save - Whether to save the change immediately
     */
    $scope.toggleRole = function toggleRole(user, role, save) {
      user.content.roles[role] = !user.content.roles[role];
      if (save) {
        saveEditUser(user);
      }
    };

    /**
     * Initiates the deletion process for the
     * user with the provided ID
     *
     * @param {string} userId - User identifier
     */
    $scope.deleteUser = function deleteUser(userId) {
      $scope.deleteConfirm = userId;
    };

    /**
     * Initiates a password reset for the user
     * with the provided ID
     *
     * @param {string} userId - User identifier
     */
    $scope.resetPassword = function resetPassword(userId) {
      UsersService
        .resetPassword(userId)
        .then(function () {
          $state.reload();
          return;
        })
        .catch(function (response) {
          console.error('Error resetting password', response);
        });
    };

    /**
     * Confirms the deletion of a user
     *
     * @param {string} userId - User identifier
     */
    $scope.confirmDeleteUser = function confirmDeleteUser(userId) {
      ModelsService
        .remove(ModelsService.find('users', 'id', userId))
        .then(function () {
          $state.reload();
          return;
        })
        .catch(function () {
          console.error('Error deleting user');
        });
    };

    /**
     * Cancels the delete operation
     */
    $scope.cancelDelete = function cancelDelete() {
      $scope.deleteConfirm = null;
    };

    /**
     * Stores the entered information
     * and moves view back into read state
     *
     * @param {Object} user - user to save
     */
    function saveEditUser(user) {
      var data;

      console.log(user);
      user.content.groups = user.content.groups.toString().split(',');
      data = {
        content: user.content
      };

      ModelsService
        .update(ModelsService.find('users', 'id', user.id), data)
        .then(function () {
          $state.reload();
          return;
        })
        .catch(function () {
          console.error('Error editing user');
        });
    }

    /**
     * Method sets user data from Model
     *
     * @private
     */
    function defineUserList() {
      $scope.users.list = UsersService.get();
    }

    /**
     * Defines the current case
     */
    function defineCurrentUser() {
      if ($state.params.userId) {
        $scope.users.current = UsersService.get($state.params.userId);
      } else {
        $scope.users.current = null;
      }
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineUserList();
      defineCurrentUser();
    }
    initialize();
  }
]);
